import { ComponentConfig } from "@measured/puck";
import { useState } from "react";
import { Section } from "@/lib/puck/components/Section";

export type AccordionProps = {
  items: {
    question: string;
    answer: string;
  }[];
};

export const Accordion: ComponentConfig<AccordionProps> = {
  label: "Accordion",
  defaultProps: {
    items: [
      {
        question: "Sample question?",
        answer: "Sample answer goes here.",
      },
    ],
  },
  fields: {
    items: {
      type: "array",
      label: "Accordion Items",
      getItemSummary: (item) => item?.question || "Accordion item",
      arrayFields: {
        question: { type: "text", label: "Question" },
        answer: { type: "textarea", label: "Answer" },
      },
    },
  },
  render: ({ items }) => (
    <Section>
      <div className="space-y-3">
        {items?.map((item, index) => (
          <AccordionItem
            key={index}
            question={item.question}
            answer={item.answer}
          />
        ))}
      </div>
    </Section>
  ),
};

const AccordionItem = ({
  question,
  answer,
}: {
  question: string;
  answer: string;
}) => {
  const [open, setOpen] = useState(false);

  return (
    <div
      className={`border border-zinc-200 rounded-xl transition-all bg-white`}
    >
      <button
        onClick={() => setOpen((o) => !o)}
        className="w-full flex justify-between items-center p-5 text-left cursor-pointer"
      >
        <span className="font-medium text-lg">{question}</span>

        <svg
          className={`transition-transform duration-300 ${
            open ? "rotate-180" : "rotate-0"
          }`}
          width="20"
          height="20"
          viewBox="0 0 20 20"
        >
          <path
            d="M5 8l5 5 5-5"
            stroke="currentColor"
            strokeWidth="2"
            fill="none"
            strokeLinecap="round"
          />
        </svg>
      </button>

      {open && (
        <div className="overflow-hidden px-5 pb-5 text-zinc-600 leading-relaxed">
          {answer}
        </div>
      )}
    </div>
  );
};
